const generateForm01 = [
  {
    label: "สาเหตุการลา", // i18n-ignore (translated at render site)
    name: "reason",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ผู้มอบหมายงานแทน", // i18n-ignore (translated at render site)
    name: "delegator",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เบอร์โทร", // i18n-ignore (translated at render site)
    name: "delegator_phone",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ระหว่างลาสามารถติดต่อได้ที่", // i18n-ignore (translated at render site)
    name: "address",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type",
    style: {},
    responsive: { sm: 12, md: 12, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },

  {
    label: "จังหวัด", // i18n-ignore (translated at render site)
    name: "province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เขต/อำเภอ", // i18n-ignore (translated at render site)
    name: "district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "แขวง/ตำบล", // i18n-ignore (translated at render site)
    name: "district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "รหัสไปรษณีย์", // i18n-ignore (translated at render site)
    name: "postcode",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เบอร์โทร", // i18n-ignore (translated at render site)
    name: "during_leave_phone",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm01;
